import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { routerActions } from 'react-router-redux'
import TextField from 'material-ui/TextField'
import Slider from 'material-ui/Slider'
import SelectField from 'material-ui/SelectField';
import Checkbox from 'material-ui/Checkbox'
import DatePicker from 'material-ui/DatePicker'



import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import {List, ListItem} from 'material-ui/List'

import Avatar from 'material-ui/Avatar'
import Colors from 'material-ui/styles/colors'
import Divider from 'material-ui/Divider'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import AutoComplete from 'material-ui/AutoComplete'
import DropDownMenu from 'material-ui/DropDownMenu'
import MenuItem from 'material-ui/MenuItem'
import Moment from 'moment'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import { getByType } from 'utils/stuff'
import {Tabs, Tab} from 'material-ui/Tabs'
import attachmentActions from 'actions/attachmentActions'


import { properties, managers, tenants, handymen, projects, tasks } from 'selectors/project'
import { sort, sortSev, sortTasks } from 'utils/stuff'
import Error from 'components/Error'
import Deleted from 'components/Deleted'
import actionBarActions from 'actions/actionbar'


import dataActions from 'actions/dataActions'
import AttachmentRender from 'components/AttachmentRender'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import rightStackActions from 'actions/rightStackActions'
import newCommentActions from 'actions/newCommentActions'

import LeftNav from 'material-ui/Drawer'
import LeftNavMenu from 'components/LeftNavMenu'

import Comments from 'components/Comments'
import { attachmentPath } from 'selectors/attachments'

let select = (state, props) => ({
	...state
	, templates: R.filter((doc) => doc.type == 'template', state.data.db)
	, managers: getByType(state, 'manager')
	, path: attachmentPath(state, props.id || props.routeParams.id)
})

let chDone = ".." + "/static/img/res/ch_green.png"
let chWip = ".." + "/static/img/res/ch_black.png"
let chPending = ".." + "/static/img/res/ch_gray.png"

const styles = {
  blocked: {
    color: "#A0A0A0",
    fontStyle: "italic"
  },
  closed: {
    textDecoration: "line-through",
  },
};

export class Template extends Component {
	constructor(props){
		super(props)
		this.state={
			tasksExpand: []
		}
	}
	render(){
		try {
			let templateID = this.props.id || this.props.routeParams.id
			let isMob = typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight)
			return(
				<div>
					<header
						style={{
							width: "100%"
						  , height: "60px"
						  , top: "0"
						  , zIndex: "5555"
						  , backgroundColor: "#00ACC1"
						  , position: "fixed"
						  , lineHeight: "60px"
						  , paddingTop: "0"
						  , borderBottom: "1px solid #e1e3e2"
						}}
						className="action-bar form-holder"
					>
							{(typeof global.md.phone() == 'string')?
								<div
									style={{
										width: "inherit"
									  , height: "inherit"
									}}
								>
									<img
										src={".." + "/static/img/hamburger.png"}
										style={{
											maxHeight: "20%"
										  , verticalAlign: "middle"
										  , marginLeft: "21px"
										}}
										onTouchTap={this.props.TOOGLE_LEFT_NAV}
									/>
									<span
										style={{
											overflow: "hidden"
										  , textOverflow: "ellipsis"
										  , whiteSpace: "nowrap"
										  , display: "inline-block"
										  , width: "50%"
										  , verticalAlign: "middle"
										  , marginLeft: "8%"
										}}
									>
										{(this.props.templates[templateID])? this.props.templates[templateID].title : ""}
									</span>
									<div
										style={{
											float: "right"
										  , width: "15%"
										  , textAlign: "right"
										  , height: "inherit"
										}}
									>
										<img
											src={".." + "/static/img/trash.png"}
											style={{
												maxHeight: "40%"
											  , verticalAlign: "middle"
											  , marginRight: "21px"
											}}
											onClick={()=> {
												this.props.DOC_DELETE(templateID)
												this.props.goBack()
											}}
										/>
									</div>
								</div>
								:
									<div id="close-project-specs"
										style={{
											lineHeight: "60px"
										}}
									>
										<svg
											width="17px"
											height="17px"
											viewBox="0 0 17 17"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											style={{
												verticalAlign: "middle"
											  , marginLeft: "25px"
											  , marginTop: "2px"
											  , cursor: "pointer"
											}}
											onClick={()=>{
												this.props.goBack()
											}}
										>
										    <title>Group</title>
										    <defs></defs>
										    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
										        <g id="Group" transform="translate(1.000000, 1.000000)" stroke="#FFF" strokeWidth="2">
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
										        </g>
										    </g>
										</svg>
										<span
											style={{
												fontSize: "24px"
											  , marginTop: "0px"
											  , marginLeft: "20px"
											  , marginTop: "4px"
											  , verticalAlign: 'middle'
											  , display: "inline-block"
											  , width: "calc(100% - 36px - 50px)"
											  , textAlign: "left"
											}}
										>
											Template
										</span>
										{(this.props.templates[templateID])?
											<svg
												width="18px"
												height="21px"
												viewBox="0 0 49 59"
												version="1.1"
												xmlns="http://www.w3.org/2000/svg"
												xmlnsXlink="http://www.w3.org/1999/xlink"
												style={{
													verticalAlign: "middle"
												  , cursor: "pointer"
												  , position: "relative"
												  , left: "-16px"
												}}
												onClick={() => {
													document.getElementsByClassName('Prompt')[0].style.marginLeft = 0
												}}
											>
											    <title>delete</title>
											    <defs></defs>
											    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											        <g id="delete" fill="#FFF">
											            <g id="Group">
											                <path d="M24.5,51 C25.052,51 25.5,50.553 25.5,50 L25.5,17 C25.5,16.447 25.052,16 24.5,16 C23.948,16 23.5,16.447 23.5,17 L23.5,50 C23.5,50.553 23.948,51 24.5,51 L24.5,51 Z" id="Shape"></path>
											                <path d="M14.5,51 C15.052,51 15.5,50.553 15.5,50 L15.5,17 C15.5,16.447 15.052,16 14.5,16 C13.948,16 13.5,16.447 13.5,17 L13.5,50 C13.5,50.553 13.948,51 14.5,51 L14.5,51 Z" id="Shape"></path>
											                <path d="M34.5,51 C35.052,51 35.5,50.553 35.5,50 L35.5,17 C35.5,16.447 35.052,16 34.5,16 C33.948,16 33.5,16.447 33.5,17 L33.5,50 C33.5,50.553 33.948,51 34.5,51 L34.5,51 Z" id="Shape"></path>
											                <path d="M47.5,6 L33.456,6 C33.346,4.75 32.961,2.642 31.643,1.289 C30.809,0.434 29.751,0 28.499,0 L18.5,0 C17.248,0 16.19,0.434 15.356,1.289 C14.038,2.642 13.653,4.75 13.543,6 L1.5,6 C0.948,6 0.5,6.447 0.5,7 C0.5,7.553 0.948,8 1.5,8 L3.541,8 L5.456,54.021 C5.493,55.743 6.565,59 10.364,59 L38.636,59 C42.435,59 43.507,55.743 43.543,54.042 L45.459,8 L47.5,8 C48.052,8 48.5,7.553 48.5,7 C48.5,6.447 48.052,6 47.5,6 L47.5,6 Z M16.792,2.681 C17.24,2.223 17.799,2 18.5,2 L28.499,2 C29.2,2 29.759,2.223 30.207,2.681 C31.012,3.504 31.335,4.952 31.447,6 L15.553,6 C15.665,4.952 15.988,3.504 16.792,2.681 L16.792,2.681 Z M41.544,53.979 C41.538,54.288 41.4,57 38.636,57 L10.364,57 C7.63,57 7.466,54.283 7.455,53.958 L5.542,8 L43.457,8 L41.544,53.979 L41.544,53.979 Z" id="Shape"></path>
											            </g>
											        </g>
											    </g>
											</svg>
										: ''
										}
									</div>
							}
  	  					{(this.props.templates[templateID])?
				  			<div
				  				style={{
				  					marginLeft: "100%"
				  				  , position: 'absolute'
				  				  , top: '10px'
				  				  , background: 'rgba(0,0,0,0.8)'
				  				  , padding: '11px'
				  				  , transition: 'all ease-in-out 0.3s'
				  				  , width: '100%'
				  				}}
				  				className="Prompt"
				  			>
				  				<span style={{verticalAlign: 'middle'}}>
				  					Are you sure you want to delete this item?
				  				</span>
				  				<div style={{float: "right", position:"relative", top:"-5px"}}>
				  					<FlatButton
				  						label="Yes"
				  						primary={true}
				  						onClick={()=> {
											this.props.DOC_DELETE(templateID)
											this.props.goBack()
										}}
				  					/>
				  					<FlatButton
				  						label="No"
				  						secondary={true}
				  						onClick={() => {
				  							document.getElementsByClassName('Prompt')[0].style.marginLeft = "100%"
				  						}}
				  					/>
				  				</div>
				  			</div>
							:''
						}
					</header>
					{(!this.props.templates[templateID])?
						<Deleted />
						:
						<Tabs
							inkBarStyle={{backgroundColor: "#23987c"}}
							tabItemContainerStyle={{backgroundColor: "#3cd2ae"}}
							style={{
								marginTop: "61px"
							}}
              				initialSelectedIndex={(this.props.routing.locationBeforeTransitions.query.comments)? 1 : 0}
						>
							<Tab
								label={<span>GENERAL</span>}
								style={{height: "48px"}}
							>
							<div
								style={{
										maxWidth: (this.props.id)? 'auto' : '800px'
									  , margin: "auto"
									  , overflow: "hidden"
									  , height: (typeof global.md.phone() == 'string')? "100vh" : "calc(100vh - 109px)"
									  , paddingLeft: (isMob)?  "" : "45px "
									  , paddingTop: (isMob)?  "" : "16px "
									  , paddingRight: (isMob)?  "" : "16px "
								}}
								speed={0.8}
					            className="area"
					            contentClassName="content"
					            horizontal={false}
								verticalScrollbarStyle={{
									width: "16px"
								  , borderRadius: "13px"
								  , marginLeft: "1px"
								  , backgroundImage: "url(/assets/manager/img/bar.png)"
								  , backgroundSize: "100%"
								  , backgroundRepeat: "no-repeat"
								  , backgroundColor: "#f5f6f5"
								  , backgroundPosition: "center"
								  , display: (isMob)? "none" :"auto"
								}}
								minScrollSize={30}
								verticalContainerStyle={{
									width: "18px"
								  , backgroundColor: "#cdcdcd"
								  , opacity: "1 "
								  , display: (isMob)? "none" :"auto"
								}}
								// ref="right-panel"
								className={(typeof global.md.phone() == 'string')? "mobile-right-panel": ""}
							>
								<div
									className="general-info logical-block"
								>
									<TextField
										style = {{
											marginLeft: "-4px "
										  , marginTop: "-10px "
										}}
										fullWidth={true}
										hintText="Project template title"
										hintStyle={{fontSize: "18px", fontStyle: "italic"}}
										underlineStyle={{borderBottom: "0px solid"}}
										inputStyle={{
											marginLeft: "2px"
										  , fontSize: "18px"
										  , fontWeight: "bold"
										}}
										defaultValue = {this.props.templates[templateID].title}
										key={`${templateID}-title`}
										onBlur={(evt) =>
											(evt.target.value.length)?
												this.props.DOC_UPDATE({
													_id: templateID
												  , title: evt.target.value
												  , comments: (!this.props.templates[templateID].comments)?
														[{
															userID: this.props.session.userID
														  , auto: true, body: 'Change title'
														  , date: new Date().valueOf()
														  , value: evt.target.value
														}]
														: [
															...this.props.templates[templateID].comments
														  , {
																userID: this.props.session.userID
															  , auto: true, body: 'Change title'
															  , date: new Date().valueOf()
															  , value: evt.target.value
															}
														]
												})
											: false
										}
									/>
								</div>
								{/*<div
									className="logical-block"
									style={{
										paddingBottom: "20px"
									}}
								>
									<p
										style={{
											marginTop: "5px"
										  , fontSize: "16px"
										  , color: "#909090"
										}}
									>
										Tasks:
									</p>
								</div>*/}
								<div
									style={{

									}}
								>
									{this.props.templates[templateID].todos.map((todo, indx) => (
										<div
											key={`${indx}`}
											className={`tasks-block logical-block collapsing ${(this.state.tasksExpand[indx])? "open" : "collapsed"}`}
											style={{
												backgroundColor: "#fafafa"
												, borderBottom: "2px solid #909090"
											}}
										>
											<div
												className="not-collapsing-element title"
													style={{
														height: "56px"
													  , lineHeight: "56px"
													  , cursor: "pointer"
													  , marginTop: "-8px"
													  , backgroundColor: "#fafafa"
													}}
												onClick={
													()=> {
														let taskExpInit = this.state.tasksExpand
														taskExpInit[indx] = !taskExpInit[indx]
														this.setState({tasksExpand: taskExpInit})
													}
												}
											>
												<span
													className={`arrow ${(this.state.tasksExpand[indx])? "open" : "collapsed"}`}
													style={{
														marginTop: "8px"
													}}
												>
												</span>
												{/*<p
													style={{
														lineHeight: "64px"
													  , margin: "0"
													  , fontSize: "16px"
													}}
												>
													{(todo.name?todo.name:"Setup new task")}
												</p>*/}
												<TextField
													style = {{
														marginLeft: "-3px"
													  , width: 'calc(100% - 40px)'
													  , marginTop: "10px"
													}}
													inputStyle={{
														marginLeft: "2px"
													  , fontSize: "16px"
													}}
													hintText="Enter task title"
													hintStyle={{fontSize: "16px", fontStyle: "italic"}}
													underlineStyle={{borderBottom: "0px solid"}}
													defaultValue={(todo.name)? todo.name: ""}
													key={`${templateID}-${indx}-task`}
													onBlur={(evt) =>(evt.target.value.length)?
															this.props.DOC_UPDATE({
																_id: templateID
															  , todos: [
																	...this.props.templates[templateID].todos.slice(0, indx)
																  , {...todo, name: evt.target.value}
																  , ...this.props.templates[templateID].todos.slice(indx + 1)
																]
			  												  , comments: (!this.props.templates[templateID].comments)?
			  														[{
			  															userID: this.props.session.userID
			  														  , auto: true, body: 'Add todo'
			  														  , date: new Date().valueOf()
			  														  , value: evt.target.value
			  														}]
			  														: [
			  															...this.props.templates[templateID].comments
			  														  , {
			  																userID: this.props.session.userID
				  														  , auto: true, body: 'Add todo'
			  															  , date: new Date().valueOf()
				  														  , value: evt.target.value
			  															}
			  														]
															})
														: false
													}
												/>
											</div>
											<div>
												<svg
													width="16px"
													height="14px"
													viewBox="0 0 49 59"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
													xmlnsXlink="http://www.w3.org/1999/xlink"
													style={{
														float: "right"
													  , marginLeft: "-2px"
													  , marginTop: "10px"
													  , color: "#00ACC1"
													  , cursor: "pointer"
													  , width: "14px"
													  , height: "18px"
													  , borderColor: "#FF0000"
													  , position: "relative"
													  , top: "32px"
													  , left: "-3px"
													}}
													onClick={() => {
														this.props.DOC_UPDATE({
															_id: templateID
														  , todos: R.remove(indx, 1, this.props.templates[templateID].todos)
														  , comments: (!this.props.templates[templateID].comments)?
																[{
																	userID: this.props.session.userID
																  , auto: true, body: 'Remove todo'
																  , date: new Date().valueOf()
																  , value: ''
																}]
																: [
																	...this.props.templates[templateID].comments
																  , {
																		userID: this.props.session.userID
																	  , auto: true, body: 'Remove todo'
																	  , date: new Date().valueOf()
																	  , value: ''
																	}
																]
														})
													}}
												>
													<title>delete</title>
													<desc>Created with Sketch.</desc>
													<defs></defs>
													<g id="Page-1" stroke="none" strokeWidth="2" fill="none" fillRule="evenodd">
														<g id="delete" fill="#fc6a5a">
															<g id="Group">
																<path d="M24.5,51 C25.052,51 25.5,50.553 25.5,50 L25.5,17 C25.5,16.447 25.052,16 24.5,16 C23.948,16 23.5,16.447 23.5,17 L23.5,50 C23.5,50.553 23.948,51 24.5,51 L24.5,51 Z" id="Shape"></path>
																<path d="M14.5,51 C15.052,51 15.5,50.553 15.5,50 L15.5,17 C15.5,16.447 15.052,16 14.5,16 C13.948,16 13.5,16.447 13.5,17 L13.5,50 C13.5,50.553 13.948,51 14.5,51 L14.5,51 Z" id="Shape"></path>
																<path d="M34.5,51 C35.052,51 35.5,50.553 35.5,50 L35.5,17 C35.5,16.447 35.052,16 34.5,16 C33.948,16 33.5,16.447 33.5,17 L33.5,50 C33.5,50.553 33.948,51 34.5,51 L34.5,51 Z" id="Shape"></path>
																<path d="M47.5,6 L33.456,6 C33.346,4.75 32.961,2.642 31.643,1.289 C30.809,0.434 29.751,0 28.499,0 L18.5,0 C17.248,0 16.19,0.434 15.356,1.289 C14.038,2.642 13.653,4.75 13.543,6 L1.5,6 C0.948,6 0.5,6.447 0.5,7 C0.5,7.553 0.948,8 1.5,8 L3.541,8 L5.456,54.021 C5.493,55.743 6.565,59 10.364,59 L38.636,59 C42.435,59 43.507,55.743 43.543,54.042 L45.459,8 L47.5,8 C48.052,8 48.5,7.553 48.5,7 C48.5,6.447 48.052,6 47.5,6 L47.5,6 Z M16.792,2.681 C17.24,2.223 17.799,2 18.5,2 L28.499,2 C29.2,2 29.759,2.223 30.207,2.681 C31.012,3.504 31.335,4.952 31.447,6 L15.553,6 C15.665,4.952 15.988,3.504 16.792,2.681 L16.792,2.681 Z M41.544,53.979 C41.538,54.288 41.4,57 38.636,57 L10.364,57 C7.63,57 7.466,54.283 7.455,53.958 L5.542,8 L43.457,8 L41.544,53.979 L41.544,53.979 Z" id="Shape"></path>
															</g>
														</g>
													</g>
												</svg>

											</div>
											<div
												style={{
													marginTop: "30px"
												}}
												className="no-underline"
											>
												<svg
													width="24px"
													height="16.8px"
													viewBox="0 0 100 70"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
													xmlnsXlink="http://www.w3.org/1999/xlink"
													style={{
														marginTop: "2px"
													  , verticalAlign: "super"
													  , marginRight: "11px"
													}}
												>
													<title>tasks</title>
													<defs></defs>
													<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<g id="tasks" fill="#00cfa8">
															<path
																d="M41.1,67.1 C41.1,68.5 40,69.6 38.6,69.6 L7.5,69.6 C3.8,69.6 0.7,66.6 0.7,62.8 L0.7,7.2 C0.7,3.5 3.7,0.4 7.5,0.4 L79.1,0.4 C82.8,0.4 85.9,3.4 85.9,7.2 L85.9,11 C85.9,12.4 84.8,13.5 83.4,13.5 C82,13.5 80.9,12.4 80.9,11 L80.9,7.2 C80.9,6.2 80.1,5.4 79.1,5.4 L7.5,5.4 C6.5,5.4 5.7,6.2 5.7,7.2 L5.7,16.5 L74.6,16.5 C76,16.5 77.1,17.6 77.1,19 C77.1,20.4 76,21.5 74.6,21.5 L5.8,21.5 L5.8,62.8 C5.8,63.8 6.6,64.6 7.6,64.6 L38.7,64.6 C40,64.6 41.1,65.7 41.1,67.1 L41.1,67.1 Z M17.7,11 C17.7,12.5 18.9,13.8 20.5,13.8 C22.1,13.8 23.3,12.6 23.3,11 C23.3,9.5 22.1,8.2 20.5,8.2 C18.9,8.2 17.7,9.4 17.7,11 L17.7,11 Z M26.8,11 C26.8,12.5 28,13.8 29.6,13.8 C31.2,13.8 32.4,12.6 32.4,11 C32.4,9.5 31.2,8.2 29.6,8.2 C28,8.2 26.8,9.4 26.8,11 L26.8,11 Z M8.6,11 C8.6,12.5 9.8,13.8 11.4,13.8 C13,13.8 14.2,12.6 14.2,11 C14.2,9.5 13,8.2 11.4,8.2 C9.8,8.2 8.6,9.4 8.6,11 L8.6,11 Z M99.2,26 C99.3,26.3 99.3,26.6 99.3,26.8 C99.2,27.9 98.7,28.9 98,29.7 C90.3,37.3 69.2,58.5 61.6,66.1 C61,66.7 60.2,67.1 59.3,67.3 C56.7,67.8 54.2,68.4 51.6,68.9 L49.4,69.4 C49.1,69.5 48.9,69.5 48.6,69.5 C47.5,69.5 46.6,69 45.9,68.2 C45.2,67.4 45,66.3 45.2,65.2 L45.5,63.7 C46.1,60.9 46.7,58 47.3,55.2 C47.5,54.4 47.9,53.7 48.5,53.1 C50.2,51.4 51.8,49.7 53.5,48.1 L59.1,42.5 C66.8,34.8 80.4,21.2 84.9,16.7 C86,15.6 87.1,15.4 87.8,15.4 L88.3,15.4 L88.5,15.4 C89.2,15.5 90,15.6 90.8,15.9 C94.4,17.3 97,19.9 98.6,23.5 C98.9,24.2 99,24.8 99.1,25.4 C99.1,25.7 99.1,25.9 99.2,26 L99.2,26 Z M88.1,32.5 L82.2,26.6 C76.2,32.6 68.1,40.8 62.7,46.1 L57,51.7 C55.4,53.3 53.7,55 52.1,56.6 C51.6,59.1 51,61.6 50.5,64.1 C53,63.6 55.5,63 58,62.5 C64.1,56.4 78.5,42 88.1,32.5 L88.1,32.5 Z M94.1,26.4 C94,26.1 94,25.8 93.9,25.6 C92.9,23.2 91.2,21.6 88.8,20.6 C88.6,20.5 88.4,20.5 88.1,20.5 L85.6,23 L91.5,28.9 C92.5,28 93.4,27.2 94.1,26.4 L94.1,26.4 Z M66.5,28.6 C66.5,27.2 65.4,26.1 64,26.1 L13.3,26.1 C11.9,26.1 10.8,27.2 10.8,28.6 C10.8,30 11.9,31.1 13.3,31.1 L64,31.1 C65.3,31.1 66.5,30 66.5,28.6 L66.5,28.6 Z M13.3,35.7 C11.9,35.7 10.8,36.8 10.8,38.2 C10.8,39.6 11.9,40.7 13.3,40.7 L51.9,40.7 C53.3,40.7 54.4,39.6 54.4,38.2 C54.4,36.8 53.3,35.7 51.9,35.7 L13.3,35.7 L13.3,35.7 Z M46.1,47.8 C46.1,46.4 45,45.3 43.6,45.3 L13.3,45.3 C11.9,45.3 10.8,46.4 10.8,47.8 C10.8,49.2 11.9,50.3 13.3,50.3 L43.6,50.3 C45,50.3 46.1,49.2 46.1,47.8 L46.1,47.8 Z M39,54.9 L13.3,54.9 C11.9,54.9 10.8,56 10.8,57.4 C10.8,58.8 11.9,59.9 13.3,59.9 L39,59.9 C40.4,59.9 41.5,58.8 41.5,57.4 C41.5,56 40.4,54.9 39,54.9 L39,54.9 Z"
																id="Shape"
															></path>
														</g>
													</g>
												</svg>
												<span
													style={{
														fontSize: "14px"
													  , verticalAlign: "top"
													}}
												>
													Task type
												</span>
												<SelectField
													value={
														(todo.taskType)?
															todo.taskType
															: "Admin"
													}
													onChange={
														(evt, a, string) => this.props.DOC_UPDATE({
															_id: templateID
														  , todos: [
																...this.props.templates[templateID].todos.slice(0, indx)
															  , {...todo, taskType: string}
															  , ...this.props.templates[templateID].todos.slice(indx + 1)
															]
														  , comments: (!this.props.templates[templateID].comments)?
																[{
																	userID: this.props.session.userID
																  , auto: true, body: 'Change todo type'
																  , date: new Date().valueOf()
																  , value: string
																}]
																: [
																	...this.props.templates[templateID].comments
																  , {
																		userID: this.props.session.userID
																	  , auto: true, body: 'Change todo type'
																	  , date: new Date().valueOf()
																	  , value: string
																	}
																]
														})
													}
													fullWidth={false}
													style = {{
														marginLeft: "20px"
													  , width: '195px'
													  , height: "38px"
													  , marginTop: "-10px"
													  , border: "1px solid #e1e4e3"
													  , borderRadius: "3px"
	  												  , paddingLeft: "10px"
													  , fontSize: "14px"
													}}
													labelStyle = {{
														top: "-8px"
													}}
													iconStyle={{
														top: "8px"
													  , right: "7px"
													}}
												>
													<MenuItem
														value="Admin"
														primaryText="Admin"
													/>
													<MenuItem
														value="Repair"
														primaryText="Repair"
													/>
													<MenuItem
														value="Agent"
														primaryText="Agent"
													/>
												</SelectField>
											</div>
											<div
												style={{
													marginTop: "34px"
												  , fontSize: "12px"
												}}
											>
												<Slider
													disabled={todo.strictStart&&todo.strictDue}
													disableFocusRipple={true}
													className="green-slider"
													description={(todo.duration)?`${todo.duration} ${(todo.duration == 1)? "day" : "days" }`: "1 day"}
													onChange={(evt, value) =>
														this.props.DOC_UPDATE({
															_id: templateID
														  , todos: [
																...this.props.templates[templateID].todos.slice(0, indx)
															  , {...todo, duration: value}
															  , ...this.props.templates[templateID].todos.slice(indx + 1)
															]
														  , comments: (!this.props.templates[templateID].comments)?
																[{
																	userID: this.props.session.userID
																  , auto: true, body: 'Change todo duration'
																  , date: new Date().valueOf()
																  , value: value
																}]
																: [
																	...this.props.templates[templateID].comments
																  , {
																		userID: this.props.session.userID
																	  , auto: true, body: 'Change todo duration'
																	  , date: new Date().valueOf()
																	  , value: value
																	}
																]
														})
													}
													value={(todo.duration)? todo.duration : 1}
													step={1} min={1} max={30}
													style={{marginBottom: '5px', marginTop: '5px' }}
												/>
												<div
													style={{
														overflow: "hidden"
													  , marginTop: "38px"
													  , marginLeft: "-4px"
													}}
												>
													<Checkbox className="startCheck"
														style={{
															width: "180px"
														  , display: "inline-block"
														}}
														id="checkbox-start"
														checked = {todo.strictStart}
														onCheck = {(evt, value) => {
															this.props.DOC_UPDATE({
																_id: templateID
															  , todos: [
																	...this.props.templates[templateID].todos.slice(0, indx)
																  , {...todo, strictStart: value}
																  , ...this.props.templates[templateID].todos.slice(indx + 1)
																]
															  , comments: (!this.props.templates[templateID].comments)?
																	[{
																		userID: this.props.session.userID
																	  , auto: true, body: 'Change todo strict start'
																	  , date: new Date().valueOf()
																	  , value: value
																	}]
																	: [
																		...this.props.templates[templateID].comments
																	  , {
																			userID: this.props.session.userID
																		  , auto: true, body: 'Change todo strict start'
																		  , date: new Date().valueOf()
																		  , value: value
																		}
																	]
															})}
														}
														label="Fixed Start Date"
														labelStyle={{
															marginLeft: "-9px"
														  , marginTop: "1px"
														  , fontWeight: "bold"
														  , fontSize: "14px"
														}}
														iconStyle={{
															fill: "rgb(0, 207, 168)"
														}}
													/>

													<Checkbox className="dueCheck"
														style={{
															width: "180px"
														  , display: "inline-block"
														  , marginLeft: "68px"
														}}
														id="checkbox-due"
														checked = {todo.strictDue}
														onCheck = {(evt, value) => {
															this.props.DOC_UPDATE({
																_id: templateID
															  , todos: [
																	...this.props.templates[templateID].todos.slice(0, indx)
																  , {...todo, strictDue: value}
																  , ...this.props.templates[templateID].todos.slice(indx + 1)
																]
															  , comments: (!this.props.templates[templateID].comments)?
																	[{
																		userID: this.props.session.userID
																	  , auto: true, body: 'Change todo strict due'
																	  , date: new Date().valueOf()
																	  , value: value
																	}]
																	: [
																		...this.props.templates[templateID].comments
																	  , {
																			userID: this.props.session.userID
																		  , auto: true, body: 'Change todo strict due'
																		  , date: new Date().valueOf()
																		  , value: value
																		}
																	]
															})}
														}
														label="Fixed Due Date"
														labelStyle={{
															marginLeft: "-12px"
														  , marginTop: "1px"
														  , fontWeight: "bold"
														  , fontSize: "14px"
														}}
														iconStyle={{
															fill: "rgb(0, 207, 168)"
														}}
													/>
												</div>

												<div style = {{paddingTop: "20px", marginBottom: "10px", clear: "both"}}>
													<div
														style={{
															overflow: "hidden"
														  , width: "142px"
														}}
													>
														{(todo.dependencies && todo.dependencies.length && todo.dependencies.length != this.props.templates[templateID].todos.length - 1)?
															<svg
																width="24px"
																height="24px"
																viewBox="0 0 24 24"
																version="1.1"
																xmlns="http://www.w3.org/2000/svg"
																xmlnsXlink="http://www.w3.org/1999/xlink"
																onClick={() =>
																	this.props.DOC_UPDATE({
																		_id: templateID
																	  , todos: [
																			...this.props.templates[templateID].todos.slice(0, indx)
																		  , {
																				...todo
																			  , dependencies: [...todo.dependencies, ""]
																			}
																		  , ...this.props.templates[templateID].todos.slice(indx + 1)
																		]
																	  , comments: (!this.props.templates[templateID].comments)?
																			[{
																				userID: this.props.session.userID
																			  , auto: true, body: 'Add empty dependency'
																			  , date: new Date().valueOf()
																			  , value: ''
																			}]
																			: [
																				...this.props.templates[templateID].comments
																			  , {
																					userID: this.props.session.userID
																				  , auto: true, body: 'Add empty dependency'
																				  , date: new Date().valueOf()
																				  , value: ''
																				}
																			]
																	})
																}
																style={{
																	verticalAlign: "middle"
																  , marginLeft: "7px"
																  , cursor: "pointer"
																  , float: "right"
																  , marginTop: "5px"
																}}
															>
																	<title>Group 2</title>
																	<defs></defs>
																	<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																		<g id="Group-2" transform="translate(1.000000, 1.000000)" stroke="#5ae4c3" strokeWidth="2">
																			<path d="M11,4.5 L11,17.5" id="Line" stroke-linecap="square"></path>
																			<path d="M5,11 L17,11" id="Line" stroke-linecap="square"></path>
																			<circle id="Oval-1" cx="11" cy="11" r="11"></circle>
																		</g>
																	</g>
															</svg>
															: (this.props.templates[templateID].todos.length > 1)?
																<svg
																	width="24px"
																	height="24px"
																	viewBox="0 0 24 24"
																	version="1.1"
																	xmlns="http://www.w3.org/2000/svg"
																	xmlnsXlink="http://www.w3.org/1999/xlink"
																	onClick={() =>
																		this.props.DOC_UPDATE({
																			_id: templateID
																		  , todos: [
																				...this.props.templates[templateID].todos.slice(0, indx)
																			  , {
																					...todo
																				  , dependencies: [...todo.dependencies, ""]
																				}
																			  , ...this.props.templates[templateID].todos.slice(indx + 1)
																			]
																		  , comments: (!this.props.templates[templateID].comments)?
																				[{
																					userID: this.props.session.userID
																				  , auto: true, body: 'Add todo dependency'
																				  , date: new Date().valueOf()
																				  , value: ''
																				}]
																				: [
																					...this.props.templates[templateID].comments
																				  , {
																						userID: this.props.session.userID
																					  , auto: true, body: 'Add todo dependency'
																					  , date: new Date().valueOf()
																					  , value: ''
																					}
																				]
																		})
																	}
																	style={{
																		verticalAlign: "middle"
																	  , marginLeft: "7px"
																	  , cursor: "pointer"
																	  , float: "right"
																	  , marginTop: "5px"
																	}}
																>
																		<title>Group 2</title>
																		<defs></defs>
																		<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																			<g id="Group-2" transform="translate(1.000000, 1.000000)" stroke="#5ae4c3" strokeWidth="2">
																				<path d="M11,4.5 L11,17.5" id="Line" stroke-linecap="square"></path>
																				<path d="M5,11 L17,11" id="Line" stroke-linecap="square"></path>
																				<circle id="Oval-1" cx="11" cy="11" r="11"></circle>
																			</g>
																		</g>
																</svg>
																: ""
														}
														<p
															style={{
																fontSize: "14px"
															  , marginTop: "10px"
															}}
														>
															Dependencies:
														</p>
													</div>
														{(todo.dependencies && todo.dependencies.length)?
															<div
																className="no-underline"
																style={{
																	marginTop: "11px"
																}}
															>
																{todo.dependencies.map((dep, index) => (
																		<div
																			style={{
																				overflow: "hidden"
																			  , height: "39px"
																			}}
																		>
						<SelectField
							key={indx + '-' + index}
							value={dep}
							fullWidth={false}
							style = {{
								width: "96%"
							  , height: "38px"
							  , border: "1px solid #e1e4e3"
							  , borderRadius: "3px"
							  , paddingLeft: "10px"
							  , fontSize: "14px"
							}}
							labelStyle = {{
								top: "-8px"
							}}
							iconStyle={{
								top: "8px"
							  , right: "7px"
							}}
							onChange={(evt, id, value)=>
								this.props.DOC_UPDATE({
									_id: templateID
								  , todos: [
										...this.props.templates[templateID].todos.slice(0, indx)
									  , {
											...todo
										  , dependencies: [
											  ...todo.dependencies.slice(0, index)
											  , value
											  , ...todo.dependencies.slice(index + 1)
											]
										}
									  , ...this.props.templates[templateID].todos.slice(indx + 1)
									]
								  , comments: (!this.props.templates[templateID].comments)?
										[{
											userID: this.props.session.userID
										  , auto: true, body: 'Change todo dependency'
										  , date: new Date().valueOf()
										  , value: ''
										}]
										: [
											...this.props.templates[templateID].comments
										  , {
												userID: this.props.session.userID
											  , auto: true, body: 'Change todo dependency'
											  , date: new Date().valueOf()
											  , value: ''
											}
										]
								})

							}
						>
							{this.props.templates[templateID].todos.map((todoSelect, todoIndx) => (
								<MenuItem
									value={todoIndx}
									primaryText={todoSelect.name}
									key={`dep-${todoIndx}-todo-item`}
									style={{
										display: (
											todo.name == todoSelect.name
											|| (!!~todo.dependencies.indexOf(todoIndx)
											&& dep == todoIndx)
										)? 'none': 'auto'
									}}
								/>
							))}
						</SelectField>
						<img
							src={".." + "/static/img/trash-red.png"}
							onClick={
								() =>
									this.props.DOC_UPDATE({
											_id: templateID
										  , todos: [
												...this.props.templates[templateID].todos.slice(0, indx)
											  , {
													...todo
												  , dependencies: R.reject(
														(dependency) => dependency == dep
														, todo.dependencies)
												}
											  , ...this.props.templates[templateID].todos.slice(indx + 1)
											]
										  , comments: (!this.props.templates[templateID].comments)?
												[{
													userID: this.props.session.userID
												  , auto: true, body: 'Remove todo dependency'
												  , date: new Date().valueOf()
												  , value: ''
												}]
												: [
													...this.props.templates[templateID].comments
												  , {
														userID: this.props.session.userID
													  , auto: true, body: 'Remove todo dependency'
													  , date: new Date().valueOf()
													  , value: ''
													}
												]
									})
							}
							style={{
								cursor: 'pointer'
							  , width: "17px"
							  , marginTop: "10px"
							  , float: "right"
							}}
						/>
																		</div>
																	))
																}

														</div>

															: ""
													}
												</div>
											</div>

										</div>
									))}
								</div>
								<RaisedButton
									label="Add new task"
									labelColor="#FFF"
									labelStyle={{top: "12px"}}
									backgroundColor="#3cd2ae"
									style={{width: "234px", marginBottom: "16px", height: "45px", marginLeft: "25px", marginTop: "45px"}}
									onClick={(evt) => {
										this.props.DOC_UPDATE({
											_id: templateID
										  , todos: [
												...this.props.templates[templateID].todos
											  , {
												  "name": "",
											      "dependencies": [],
											      "duration": 1,
											      "strictStart": false,
											      "strictDue": false
											  }
											]
										  , comments: (!this.props.templates[templateID].comments)?
												[{
													userID: this.props.session.userID
												  , auto: true, body: 'Add todo'
												  , date: new Date().valueOf()
												  , value: ''
												}]
												: [
													...this.props.templates[templateID].comments
												  , {
														userID: this.props.session.userID
													  , auto: true, body: 'Add todo'
													  , date: new Date().valueOf()
													  , value: ''
													}
												]
										})
									}}
								/>
							</div>
						</Tab>

					</Tabs>
					}
				</div>
			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}
}
export default connect(select, R.mergeAll([dataActions, routerActions, attachmentOverlayActions, attachmentActions, actionBarActions, newCommentActions, rightStackActions]))(Template)



// WEBPACK FOOTER //
// ./src/routes/manager/templateForm/index.js